var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-row"},[_c('div',{staticClass:"header-row__title"},[_c('CPageTitle',{attrs:{"page-title":_vm.pageTitle,"tooltip-text":_vm.tooltipText}},[_vm._t("default")],2),_c('div',{staticClass:"header-row__mobile-slot"},[_vm._t("mobile-menu")],2)],1),_c('div',{staticClass:"header-row__right-side"},[_vm._t("right-side")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }